import { isSemrush } from '/src/utils/semrush';

export const DATE_QUERY_PARAM = 'date';
export const SEMRUSH_DATE_QUERY_PARAM = 'd';
export const DEVICE_QUERY_PARAM = 'device';
export const SEMRUSH_DEVICE_QUERY_PARAM = 'dv';

export function getQueryParamKeys(key) {
  if (key === DATE_QUERY_PARAM) {
    if (isSemrush) {
      return { preferredKey: SEMRUSH_DATE_QUERY_PARAM, fallbackKey: DATE_QUERY_PARAM };
    }

    return { preferredKey: DATE_QUERY_PARAM, fallbackKey: SEMRUSH_DATE_QUERY_PARAM };
  }

  if (key === DEVICE_QUERY_PARAM) {
    if (isSemrush) {
      return { preferredKey: SEMRUSH_DEVICE_QUERY_PARAM, fallbackKey: DEVICE_QUERY_PARAM };
    }

    return { preferredKey: DEVICE_QUERY_PARAM, fallbackKey: SEMRUSH_DEVICE_QUERY_PARAM };
  }

  return { preferredKey: key, fallbackKey: null };
}
